import { useTranslation } from 'react-i18next';
import { S, Icon, Icons, BtnSecondary } from '../regureStyles';

const Header = ({ fetchCommissions }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
          {t('screens.commissions.breadcrumbOps')} {Icons.chevronRight(S.textMuted, 12)} <span style={{ color: S.textPrimary, fontWeight: 500 }}>{t('screens.commissions.breadcrumbCurrent')}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('screens.commissions.title')}</div>
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <BtnSecondary onClick={fetchCommissions}>
          <Icon name='file-text' color={S.textMuted} size={15} /> {t('screens.commissions.refresh')}
        </BtnSecondary>
      </div>
    </header>
  );
};

export default Header;
